// extracted by mini-css-extract-plugin
export default {"wrapper":"UserProfileDetails_wrapper__CCTsF","actions":"UserProfileDetails_actions__YlBWx"};